/**
 * Announcement bar — one slide visible, auto-rotate, pause on hover/focus.
 */
(function () {
  if (window._mfrAlpineRegistered?.announcementBarCarousel) return;
  window._mfrAlpineRegistered = window._mfrAlpineRegistered || {};
  window._mfrAlpineRegistered.announcementBarCarousel = true;

  document.addEventListener('alpine:init', () => {
    Alpine.data('announcementBarCarousel', (config) => ({
      activeIndex: 0,
      count: config.count || 0,
      intervalMs: config.intervalMs || 5000,
      autoRotate: config.autoRotate !== false,
      paused: false,
      timer: null,

      init() {
        if (this.count <= 1 || !this.autoRotate) return;
        this.startTimer();
        this.$el.addEventListener('focusin', () => this.pause());
        this.$el.addEventListener('focusout', () => {
          requestAnimationFrame(() => {
            if (!this.$el.contains(document.activeElement)) this.resume();
          });
        });
      },

      startTimer() {
        this.stopTimer();
        if (this.count <= 1 || !this.autoRotate) return;
        this.timer = setInterval(() => {
          if (!this.paused) this.next();
        }, this.intervalMs);
      },

      stopTimer() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },

      pause() {
        this.paused = true;
      },

      resume() {
        this.paused = false;
      },

      next() {
        if (this.count <= 1) return;
        this.activeIndex = (this.activeIndex + 1) % this.count;
      },
    }));
  });
})();
